import axios from 'axios'
import router from '@/router'
import {
	ElMessage
} from 'element-plus'
import store from '@/store'

const request = axios.create({
	baseURL: "https://clp.jtcloud.icu/api/v1",
	timeout: 600000
})

// 标志位
let isRedirecting = false
let isShowing401Message = false // 新增：标记是否正在显示401消息

// 请求拦截器
request.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token')
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
request.interceptors.response.use(
	response => {
		return response
	},
	error => {
		if (!error.response) {
			ElMessage.error('网络错误，请检查网络连接')
			return Promise.reject(error)
		}

		const {
			status
		} = error.response

		// 特殊处理401
		if (status === 401) {
			// 防止重复显示消息
			if (!isShowing401Message) {
				isShowing401Message = true

				// 清除token
				localStorage.removeItem('token')

				// 显示消息（只显示一次）
				ElMessage.error('登录已过期，请重新登录')

				// 避免与当前路由冲突
				if (router.currentRoute.value.path !== '/login' && !isRedirecting) {
					isRedirecting = true
					store.commit('Login_dialog_show')

					// 3秒后重置跳转标志
					setTimeout(() => {
						isRedirecting = false
					}, 3000)
				}

				// 5秒后重置消息标志，允许再次显示
				setTimeout(() => {
					isShowing401Message = false
				}, 5000)
			}
		} else {
			ElMessage.error(error.response.data?.msg || `请求错误: ${status}`)
		}

		return Promise.reject(error)
	}
)

export default request